module.exports = __webpack_public_path__ + "static/media/logo@2x.110a912a.png";